module.exports = __webpack_public_path__ + "static/media/nft3.94f04888.png";